import { useState, useEffect } from "react";
import { motion, AnimatePresence, color } from "framer-motion";
import "../styles/MasterPlanPreview.css";
import masterplan from "../assets/serene-images/serene-webverse-screenshot.avif"


export default function MasterPlanPreview() {
  const [redirecting, setRedirecting] = useState(false);
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        setRedirecting(false);
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleRedirect = () => {
    setRedirecting(true);
    setTimeout(() => {
      window.location.href = "https://vessella.com/serene-masterplan/";
    }, 900);
  };

  /* ---- ANIMATIONS ---- */

  const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  const wordContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.04,
        delayChildren: 0.06,
      },
    },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  const line1 = "Where Elegance".split(" ");
  const line2 = "Becomes Home".split(" ");

  return (
    <>
      {/* ===== TOP TEXT (NORMAL WIDTH) ===== */}
      <section className="mp-text-section pb-lg-0" id="serene-masterplan">
        <div className="container">
          <div className="row mb-lg-5 flex-lg-wrap flex-wrap-reverse">

            <div className="col-lg-5">

              <motion.p
                className="about-text"
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.6 }}
              >
                The master plan of Serene is meticulously designed to balance elegant
                architecture with expansive green spaces. Every element is thoughtfully
                placed to ensure privacy, seamless movement, and a refined living experience.
              </motion.p>

              <motion.a
                onClick={handleRedirect}
                className="location-btn d-inline-flex d-lg-none align-items-center text-decoration-none"
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.6 }}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
              >
                Explore Floor Plans
                <i className="fa-solid fa-arrow-right ms-2"></i>
              </motion.a>
            </div>

            <div className="col-lg-7 text-end">

              <motion.h1
                className="sage-title display-4"
                variants={wordContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.6 }}
              >
                {line1.map((word, i) => (
                  <motion.span
                    key={`l1-${i}`}
                    variants={wordVariant}
                    style={{ display: "inline-block", marginRight: "0.35em" }}
                  >
                    {word}
                  </motion.span>
                ))}
                <br />
                {line2.map((word, i) => (
                  <motion.span
                    key={`l2-${i}`}
                    variants={wordVariant}
                    style={{ display: "inline-block", marginRight: "0.35em" }}
                  >
                    {word}
                  </motion.span>
                ))}
              </motion.h1>

            </div>

          </div>
        </div>
      </section>


      {/* ===== FULL WIDTH IMAGE AREA ONLY ===== */}


      <section className="mp-image-section">

        <div className="container-fluid p-0">
          <motion.div
            className={`mp-preview ${mapLoaded ? "loaded" : ""}`}
            initial={false}
            animate={mapLoaded ? { opacity: 1, scale: 1 } : { opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            {/* {!mapLoaded && (
                            <div className="mp-loader">
                                Loading Interactive Map...
                            </div>
                        )} */}



            <iframe
              className="d-none d-lg-block"
              src="https://vessella.com/serene-masterplan/"
              title="Interactive Master Plan"
              loading="eager"

              onLoad={() => setMapLoaded(true)}
            />

            <motion.a
              onClick={handleRedirect}
              className="location-btn d-lg-inline-flex d-none align-items-center text-decoration-none map-btn"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.6 }}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
            >
              Explore Floor Plans
              <i className="fa-solid fa-arrow-right ms-2"></i>
            </motion.a>

            <div className="mp-layout-image-container d-block d-lg-none">



              <img
                src={masterplan}
                className="img-fluid"
                alt=""
                onClick={handleRedirect}
                style={{ cursor: "pointer" }}
              />
            </div>


            {/* 
                        {mapLoaded && (
                            <>
                                <div className="mp-preview-overlay" onClick={handleRedirect} />

                                <motion.a
                                    className="location-btn map-btn "
                                    onClick={handleRedirect}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.12 }}
                                    style={{ color: "#fff", border: "1px solid #fff", textDecoration: "none" }}
                                >
                                   Explore Floor Plans
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </motion.a>
                            </>
                        )} */}

          </motion.div>


        </div>

      </section>


      {/* ===== TRANSITION ===== */}
      <AnimatePresence>
        {redirecting && (
          <motion.div
            className="fullscreen-transition"
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 0.4, ease: [0.77, 0, 0.175, 1] }}
          />
        )}
      </AnimatePresence>
    </>
  );
}
